import React from "react";
import { Checkbox } from "@glamcorner/components/lib/core/components/Checkbox";
import { Accordion } from "@glamcorner/components/lib/core/components/Accordion";
import { SSRClassFix } from "../../../../components/SSRClassFix";
import "./designation-panel.scss";

export type DesignationPanelField = {
  label: string;
  component: React.ReactNode;
  error: string | undefined;
  wrapperClass?: string;
};

export type DesignationPanelProps = {
  isSelected: boolean;
  title: string;
  subTitle: string;
  onSelect: () => void;
  fields: DesignationPanelField[][];
};
export const DesignationPanel: React.FC<DesignationPanelProps> = ({
  fields,
  isSelected,
  title,
  subTitle,
  onSelect,
  children,
}) => {
  const headerElement = (
    <div className="c-designation-panel__header">
      <SSRClassFix>
        <Checkbox
          isSelected={isSelected}
          onSelect={() => {
            /* because it would cause double select with accordion header  */
          }}
        />
      </SSRClassFix>

      <span className="c-designation-panel__title">{title}</span>
      <span className="c-designation-panel__sub-title">{subTitle}</span>
    </div>
  );

  return (
    <div className="c-designation-panel">
      <Accordion title={headerElement} isOpen={isSelected} controlled onClick={(_isOpen) => onSelect()}>
        <div className="c-designation-panel__content">
          {fields.map((row, index) => {
            return (
              <div key={`panel-wrapper-${index}`} className="c-designation-panel__fields__wrapper">
                {row.map((field) => {
                  return (
                    <div
                      key={`panel-field-${field.label}`}
                      className={`c-designation-panel__field-and-label ${field.wrapperClass ? field.wrapperClass : ""}`}
                    >
                      <div className="c-designation-panel__label">
                        {field.label}
                        {field.error && <div className="c-designation-panel__label--error">{field.error}</div>}
                      </div>
                      {field.component}
                    </div>
                  );
                })}
              </div>
            );
          })}
          {children}
        </div>
      </Accordion>
    </div>
  );
};
